export default "__VITE_ASSET__BI85Z6lP__"